// extracted by mini-css-extract-plugin
export default {"root":"awL6G8fk1qShZNI6L4o6","downloadIcon":"wubMqSrytn4PhQFmQQOL","exportBtn":"dYoxjznCfo9bi4_Gx7ok"};